import { render, staticRenderFns } from "./SwitchControl.vue?vue&type=template&id=4d8d0213&scoped=true"
import script from "./SwitchControl.vue?vue&type=script&lang=js"
export * from "./SwitchControl.vue?vue&type=script&lang=js"
import style0 from "./SwitchControl.vue?vue&type=style&index=0&id=4d8d0213&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8d0213",
  null
  
)

export default component.exports